import { Component, OnInit, OnChanges, SimpleChanges, Input, EventEmitter, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SpinnerService } from '../../../../../services/spinner.service';
import { AppData } from '../../../../../models/appdata';
import { ApiResponseModel } from '../../../../../models/api_response_model';
import { HCPService } from '../../../../../services/hcp.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActorPersonalDetailInfoRequest, ActorPersonalDetailInfoController, ActorContactInfoController, ActorContactInfoRequest } from '../../../../../models/profileinfo/profileinfo.model';
import { ActorImageController, OTFormsByFormattedCodeController, OTFormDetailByReportCodeRequest, OTFormsByFormattedCodeRequest, OTFormDetailByReportCodeController, SectionData, FormOrganizer, DeletePatientHealthRecordRequest, GenericProcPostRequest, S_Methods, FieldData } from '../../../../../models/actor/actor';
import * as alertFunctions from '../../../../../../shared/data/sweet-alerts';
import { CustomDateTimeService } from '../../../../../services/datetime.service';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateParserFormatter, NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';
import { NGXToastrService } from '../../../../../../shared/services/toastr.service';
import { ActorService } from '../../../../../../../../src/app/ncs/services/actor.service';
import { NgbFsEditAttrModal } from './modal/fseditattr.modal';
import { NgbFsEditTextModal } from './modal/fsedittext.modal';
import { NgbFsEditImageModal } from './modal/fseditimage.modal';
import { NgbFsEditViewModal } from './modal/fseditview.modal';
import { PrintService } from '../../../../../../../../src/app/ncs/services/print.service';
import { NgbAddFormsModal } from './modal/addforms.modal';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
    selector: 'viewedittext',
    templateUrl: './viewedittext.component.html',
    styleUrls: ['./viewedittext.component.scss']
})

export class ViewEditTextComponent implements OnInit, OnChanges {
    @Input() ActorCode: number;
    @Input() ActorType: number;
    @Input() FormattedCode: string;
    @Input() CanEdit: number;
    @Input() CanShow: number;
    @Input() PatientCode: number;

    ngOnChanges(changes: SimpleChanges) {
        if ((changes['FormattedCode'] && changes['FormattedCode'].currentValue) || (changes['ActorCode'] && changes['ActorCode'].currentValue)) {
            this.LoadMedicalRecords();
        }
    }
    //@Input() reportCode: number;
    //@Input() TemplateName: string;
    //@Input() Date: Date;
    //@Input() Sign1: string;
    //@Input() Sign2: string;
    public isRequesting: boolean = false;
    public ListView: boolean = true;
    public backtolist: boolean = false;
    public FormList: boolean = false;
    public Formedit: boolean = false;
    public viewhealthrecord: boolean = false;
    public TemplateName: string;
    public Date: Date;
    public Sign1: string;

  public Sign2: string;
  public RPCode: any;
    CurrentActorPersonalDetailInfoRequest: ActorPersonalDetailInfoRequest;
    CurrentActorPersonalDetailInfoController: ActorPersonalDetailInfoController;

    ValueChangeActorImageController: ActorImageController;

    public ApiResData: ApiResponseModel;

    public MaxDateV = new Date();
    public CanAdjustgetTimezoneOffset: boolean;
    public MinDateV = new Date();
    public PatientFormattedCode: string;

    DOB: NgbDateStruct;



    maxDate: NgbDateStruct;
    minDate: NgbDateStruct;

    //
  public key: ActorPersonalDetailInfoController;
  

    @Input()
    get Key() {
        return this.key;
    }

    @Output() personalInfoChange = new EventEmitter();
    //set Key(value: ActorPersonalDetailInfoController) {
    //  this.key = value;
    //  //  alertFunctions.AlertParam(this.Key);
    //  console.log('personalInfoChange');
    //  this.personalInfoChange.emit(this.key);
    //}
    //
    public onInput(value: Date): void {

        console.log('value-->' + value);

        this.CurrentActorPersonalDetailInfoRequest.DateOfBirth = value;
    }
    //CurrentOTFormsByFormattedCodeController: OTFormsByFormattedCodeController[];
    //CurrentOTFormsByFormattedCodeRequest: OTFormsByFormattedCodeRequest;

    //OpenForm(data: OTFormsByFormattedCodeController) {
    //  this.LoadMedicalHistory(data.PatientReportCode);
    //  this.ListView = false;
    //  this.backtolist = true;

    //}
    //LoadMedicalRecords() {
    //  this.CurrentOTFormsByFormattedCodeRequest = new OTFormsByFormattedCodeRequest();

    //  this.CurrentOTFormsByFormattedCodeRequest.ConditionalOperator = 10;
    //  this.CurrentOTFormsByFormattedCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    //  this.GetOTFormsByFormattedCodeController();

    //}

    //GetOTFormsByFormattedCodeController() {
    //  if (isNaN(this.ActorCode))
    //    return;

    // // alert('loading forms: ' + this.ActorCode);
    //  this.StartRefreshing();
    //  this.CurrentOTFormsByFormattedCodeRequest.FormattedCode = this.FormattedCode;
    //  //alert('loading forms: ' + this.FormattedCode);
    //  //this.LoadMedicalHistory_new();


    //  //alert("LOading guarding adata");
    //  //alert(this.CurrentGuardianInfoRequest.ActorCode);

    //  this.actorservice.GetOTFormsByFormattedCodeController(this.CurrentOTFormsByFormattedCodeRequest)
    //    .subscribe((result) => {
    //      this.ApiResData = result;
    //      if (!this.ApiResData.hasError) {

    //       this.CurrentOTFormsByFormattedCodeController = this.ApiResData.Result;
    //        //var reportCode: number =
    //        //  this.CurrentOTFormsByFormattedCodeController.filter
    //        //    (x => x.ReportType != 'VIT' && x.TemplateName == 'Medical History')[0].PatientReportCode;
    //        //this.stopRefreshing();

    //        //this.LoadMedicalHistory(reportCode);
    //        this.stopRefreshing();
    //      }
    //      else {
    //        this.stopRefreshing();
    //        if (this.ApiResData.ErrorData != "") {

    //          alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
    //        }
    //        else {
    //          alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
    //        }
    //      }

    //    },


    //      (error) => {

    //        if (error == "401 - Unauthorized") {
    //          alertFunctions.AlertParamEr(error);
    //          this.stopRefreshing();



    //        }
    //        else {
    //          alertFunctions.AlertParamEr(error);
    //          this.stopRefreshing();
    //        }
    //      }


    //    );
    //}
    CurrentOTFormsByFormattedCodeController: OTFormsByFormattedCodeController[];
    CurrentOTFormsByFormattedCodeRequest: OTFormsByFormattedCodeRequest;

    public viewmode: string = 'view';
    public fo: FormOrganizer;

    SetForm() {
        this.fo = new FormOrganizer();
        this.fo.Sections = new Array<SectionData>();

        if (!this.FormData || this.FormData.length === 0) {
            return;
        }

        // Check if FormData elements are already SectionData objects with a Fields or fields array
        const firstItem: any = this.FormData[0];
        const fieldsArray = firstItem ? (firstItem.Fields || firstItem.fields) : null;

        if (fieldsArray && Array.isArray(fieldsArray)) {
            for (let i = 0; i < this.FormData.length; i++) {
                let sec: any = this.FormData[i];
                if (!sec.Fields && sec.fields) sec.Fields = sec.fields;
                if (!sec.Title && sec.title) sec.Title = sec.title;
                if (sec.sectionTypeCode !== undefined && sec.SectionTypeCode === undefined) sec.SectionTypeCode = sec.sectionTypeCode;
                if (sec.sectionSequenceNO !== undefined && sec.SectionSequenceNO === undefined) sec.SectionSequenceNO = sec.sectionSequenceNO;
                if (!sec.SectionType && sec.sectionType) sec.SectionType = sec.sectionType;

                if (!sec.SectionType) {
                    if (sec.SectionTypeCode === 2) sec.SectionType = 'Text';
                    else if (sec.SectionTypeCode === 3) sec.SectionType = 'Image';
                    else sec.SectionType = 'AttrVal';
                }

                if (sec.Fields) {
                    for (let f of sec.Fields) {
                        if (f.valueType && !f.ValueType) f.ValueType = f.valueType;
                        if (f.title && !f.Title) f.Title = f.title;
                        if (f.value !== undefined && f.Value === undefined) f.Value = f.value;
                        if (f.remarks !== undefined && f.Remarks === undefined) f.Remarks = f.remarks;
                        if (f.hasChildAttributes !== undefined && f.HasChildAttributes === undefined) f.HasChildAttributes = f.hasChildAttributes;
                        if (f.templateItemCode !== undefined && f.TemplateItemCode === undefined) f.TemplateItemCode = f.templateItemCode;
                        if (f.parentCode !== undefined && f.ParentCode === undefined) f.ParentCode = f.parentCode;
                        if (f.rootCOde !== undefined && f.RootCOde === undefined) f.RootCOde = f.rootCOde;
                        if (f.sequenceNo !== undefined && f.SequenceNo === undefined) f.SequenceNo = f.sequenceNo;
                    }
                }
                this.fo.Sections.push(sec);
            }
        } else {
            // FormData is a flat array of attribute rows returned from GetOTFormDetailByReportCodeController
            const sectionMap = new Map<string, SectionData>();

            for (let rawRow of (this.FormData as any[])) {
                const title = rawRow.SectionTitle || rawRow.Title || rawRow.sectionTitle || 'General';
                let sec = sectionMap.get(title);

                if (!sec) {
                    sec = new SectionData();
                    sec.Title = title;
                    sec.SectionSequenceNO = rawRow.SectionSequenceNO || rawRow.sectionSequenceNO || 0;
                    sec.SectionTypeCode = rawRow.SectionTypeCode || rawRow.sectionTypeCode || 1;

                    // Map SectionTypeCode or SectionType to SectionType string
                    const rawSecType = rawRow.SectionType || rawRow.sectionType;
                    const valType = rawRow.ValueType || rawRow.valueType;
                    if (rawSecType) {
                        sec.SectionType = rawSecType;
                    } else if (sec.SectionTypeCode === 2 || valType === 'Text' || valType === 'TextArea') {
                        sec.SectionType = 'Text';
                    } else if (sec.SectionTypeCode === 3 || valType === 'Image') {
                        sec.SectionType = 'Image';
                    } else {
                        sec.SectionType = 'AttrVal';
                    }

                    sec.Fields = new Array<FieldData>();
                    sectionMap.set(title, sec);
                }

                // Create FieldData for this raw attribute row
                const field = new FieldData();
                field.Title = rawRow.AttributeName || rawRow.Title || rawRow.attributeName || '';
                const rawVal = rawRow.ValueData !== undefined ? rawRow.ValueData : (rawRow.valueData !== undefined ? rawRow.valueData : rawRow.Value);
                field.Value = rawVal !== undefined && rawVal !== null ? rawVal.toString() : '';
                field.ValueType = rawRow.ValueType || rawRow.valueType || 'Text';
                field.SequenceNo = rawRow.SequenceNo || rawRow.sequenceNo || 0;
                field.HasUnit = rawRow.HasUnit || rawRow.hasUnit || false;
                field.Unit = rawRow.Unit || rawRow.unit || '';
                field.UOM = rawRow.UOM || rawRow.uom || rawRow.Unit || '';
                field.Unitsdata = rawRow.Unitsdata || rawRow.unitsdata || rawRow.UnitsData || '';
                field.ValueSource = rawRow.ValueSource || rawRow.valueSource || '';
                field.HasChildAttributes = rawRow.HasChildAttributes || rawRow.hasChildAttributes || false;
                field.RootCOde = rawRow.RootCOde || rawRow.rootCOde || rawRow.RootCode || 0;
                field.ParentCode = rawRow.ParentCode || rawRow.parentCode || 0;
                field.TemplateItemCode = rawRow.TemplateItemCode || rawRow.templateItemCode || 0;
                field.DataKey = rawRow.DataKey || rawRow.dataKey || 0;
                field.Remarks = rawRow.remarks || rawRow.Remarks || '';

                sec.Fields.push(field);
            }

            sectionMap.forEach(sec => this.fo.Sections.push(sec));
        }

        this.fo.Organize();
    }


    LoadMedicalRecords() {
        // alert("one");
        this.CurrentOTFormsByFormattedCodeRequest = new OTFormsByFormattedCodeRequest();

        this.CurrentOTFormsByFormattedCodeRequest.ConditionalOperator = 10;
        this.CurrentOTFormsByFormattedCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetOTFormsByFormattedCodeController();

    }

    GetOTFormsByFormattedCodeController() {
        if (isNaN(this.ActorCode))
            return;

        // alert('loading forms: ' + this.ActorCode);
        this.StartRefreshing();
        this.CurrentOTFormsByFormattedCodeRequest.FormattedCode = this.FormattedCode;
        //alert('loading forms: ' + this.FormattedCode);
        //this.LoadMedicalHistory_new();


        //alert("LOading guarding adata");
        //alert(this.CurrentGuardianInfoRequest.ActorCode);

        this.actorservice.GetOTFormsByFormattedCodeController(this.CurrentOTFormsByFormattedCodeRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    this.CurrentOTFormsByFormattedCodeController = this.ApiResData.Result;
                    //var reportCode: number =
                    //  this.CurrentOTFormsByFormattedCodeController.filter
                    //    (x => x.ReportType != 'VIT' && x.TemplateName == 'Medical History')[0].PatientReportCode;
                    //this.stopRefreshing();

                    //this.LoadMedicalHistory(reportCode);
                    this.stopRefreshing();
                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }

    

    Backtolist() {
        this.FormList = true;
        this.Formedit = false;
    }

    BackToHealthrecords() {
        //this.viewhealthrecord = true;
        this.ListView = true;
        this.FormList = false;
        //this.Formedit = false;
        //this.router.navigate(['healins/MedicalRecords']);
    }


    gotolink(title: string, num: number) {

        var linkname: string = "title_num_" + num.toString();
      //  alert(linkname);
        let m = document.querySelector("#" + linkname);
        if (m) {
            m.scrollIntoView({ block: "center", inline: "start" });
        }
    }
   
    //GetOTFormDetailByReportCodeController() {
    //  this.StartRefreshing();
    ////  //alert("LOading guarding adata");
    ////  //alert(this.CurrentGuardianInfoRequest.ActorCode);

    //  this.actorservice.GetOTFormsByFormattedCodeController(this.CurrentOTFormsByFormattedCodeRequest)
    //    .subscribe((result) => {
    //     this.ApiResData = result;
    //      if (!this.ApiResData.hasError) {

    //        this.CurrentOTFormsByFormattedCodeController = this.ApiResData.Result;
    ////        //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController;

    ////        //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
    ////        //this.CurrentServiceDetailsByCodeRequest.ServiceCode = this.ServiceCode;
    //     this.stopRefreshing();

    //      }
    //    else {
    //        this.stopRefreshing();
    //        if (this.ApiResData.ErrorData != "") {

    //          alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
    //        }
    //        else {
    //         alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
    //       }
    //      }

    //    },


    //  (error) => {

    //        if (error == "401 - Unauthorized") {
    //          alertFunctions.AlertParamEr(error);
    //          this.stopRefreshing();



    //     }
    //        else {
    //          alertFunctions.AlertParamEr(error);
    //          this.stopRefreshing();
    //        }
    //    }


    //    );
    //}
  constructor(private router: Router,
        public printService: PrintService,
        private route: ActivatedRoute, private loaderService: SpinnerService, private hcpservice: HCPService, private actorservice: ActorService,
        private modalService: NgbModal, private customdatetimeservice: CustomDateTimeService,
      private parserFormatter: NgbDateParserFormatter, private spinner: NgxSpinnerService, private tosterservice: NGXToastrService) {
        //stepObject.init();
    }

    ngOnInit() {
        this.LoadMedicalRecords();
        //this.LoadMedicalHistory();
        this.PatientFormattedCode = this.FormattedCode;
        //alert(this.PatientFormattedCode);
        ////this.LoadMedicalHistroy();
        //this.MinDateV.setFullYear(this.MinDateV.getFullYear() - 80);
        //this.maxDate = { year: this.MaxDateV.getFullYear(), month: this.MaxDateV.getMonth() + 1, day: this.MaxDateV.getDate() };
        //this.minDate = { year: 1900, month: 1, day: 1 };

        //this.CanAdjustgetTimezoneOffset = AppData.CanAdjustgetTimezoneOffset;
        //this.CurrentActorPersonalDetailInfoRequest = new ActorPersonalDetailInfoRequest();
        //this.CurrentActorPersonalDetailInfoController = new ActorPersonalDetailInfoController();
        //this.CurrentActorPersonalDetailInfoRequest.ConditionalOperator = 2;
        //this.CurrentActorPersonalDetailInfoRequest.ActorCode = this.ActorCode;
        //this.CurrentActorPersonalDetailInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        //this.ValueChangeActorImageController = new ActorImageController();
        //if (this.CanShow === 1) {
        //  this.GetActorPersonalDetailInfoController();
        //}

    }

    onactorImageInfoChange(event: any) {


        if (event != null) {

            this.ValueChangeActorImageController = event;

            if (this.ValueChangeActorImageController.ActorImageFileUrl != null) {
                //console.log('this.ValueChangeActorImageController.ActorImageFileUrl-->' + this.ValueChangeActorImageController.ActorImageFileUrl);

                this.CurrentActorPersonalDetailInfoController.ActorImageFileUrl = this.ValueChangeActorImageController.ActorImageFileUrl;
            }


        }

    }
    onSubmit() {

        this.StartRefreshing();

        //if (this.CanAdjustgetTimezoneOffset === true) {
        //  console.log('DateOfBirth----------' + this.CurrentActorPersonalDetailInfoRequest.DateOfBirth);
        //  this.CurrentActorPersonalDetailInfoRequest.DateOfBirth = this.customdatetimeservice.converToLocalTime(this.CurrentActorPersonalDetailInfoRequest.DateOfBirth);
        //  console.log('DateOfBirth----------' + this.CurrentActorPersonalDetailInfoRequest.DateOfBirth);
        //}
        // console.log('this.DOB--->' + this.DOB);
        if (this.DOB != null) {



            this.CurrentActorPersonalDetailInfoRequest.DateOfBirth = new Date(this.parserFormatter.format(this.DOB));;

            // console.log('this.DateOfBirth--->' + this.CurrentActorPersonalDetailInfoRequest.DateOfBirth );
        }
        this.hcpservice.SaveActorPersonalDetailInfo(this.CurrentActorPersonalDetailInfoRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    if (this.ApiResData.Result > 0) {
                        this.GetActorPersonalDetailInfoController();

                        // alertFunctions.AlertParam('Saved Successfully.....!');

                        this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');



                        this.stopRefreshing();
                    }
                    else {
                        alertFunctions.AlertParam("Invalid Operation...!");


                        this.stopRefreshing();

                    }

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);



                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);

                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);

                        this.stopRefreshing();
                    }
                }
            );

    }
    //Back() {
    //    this.ListView = true;
    //    this.backtolist = false;
    //}
    //ngAfterViewInit() {
    //  //pSteps.loadStep();
    //}
    OpenForm(l: OTFormsByFormattedCodeController) {
        var reportcode = l.PatientReportCode;
        //alert(reportcode);
        this.ListView = false;
        this.FormList = true;
        
        this.LoadMedicalHistory(reportcode);
        this.TemplateName = l.TemplateName;
        this.Date = l.PatientReportDate;
        this.Sign1 = l.Sign1Name;
        this.Sign2 = l.Sign2Name;
    }    
    FormData: SectionData[];
    CurrentOTFormDetailByReportCodeController: OTFormDetailByReportCodeController[];
    CurrentOTFormDetailByReportCodeRequest: OTFormDetailByReportCodeRequest;
    LoadMedicalHistory(reportcode: number) {
        this.spinner.show();
        var r1: OTFormDetailByReportCodeRequest = new OTFormDetailByReportCodeRequest();
        r1.ConditionalOperator = 10;

        r1.PatientReportCode = reportcode.toString();
        this.RPCode = reportcode.toString();
        r1.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.actorservice.GetOTFormDetailByReportCodeController(r1).subscribe
            ((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {
                    this.stopRefreshing();
                    //  this.CurrentOTFormDetailByReportCodeController = this.ApiResData.Result;
                    //alert(this.CurrentOTFormDetailByReportCodeController);
                    // var reportCode: number = this.CurrentOTFormsByFormattedCodeController[0].PatientReportCode;
                    this.FormData = this.ApiResData.Result;
                    //alert(this.FormData.length);
                    this.SetForm();
                    //if (this.FormData.length > 0)
                    //  alert(this.FormData[0].Title);
                    //else {
                    //  alert("no data retrieved");
                    //}
                    this.spinner.hide();
                    this.stopRefreshing();

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );

    }
  DeleteForm(l) {
    swal({
      title: 'Are you sure?',
      text: "You want to delete!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0CC27E',
      cancelButtonColor: '#FF586B',
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      confirmButtonClass: 'btn btn-success btn-raised mr-5',
      cancelButtonClass: 'btn btn-danger btn-raised',
      allowOutsideClick: false,
      buttonsStyling: false
    }).then(() => {

      this.DeleteForm2(l);

      //this.DeleteActorIdentitiesMedicine(l);
      // alertFunctions.AlertParam('Delete Successfully...!');

    }, function (dismiss) {
      // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
      if (dismiss === 'cancel') {
        swal(
          'Cancelled',
          'Delete Operation Cancelled :)',
          'error'
        )
      }
    })

  }
  DeleteForm2(l) {
    var saveReq = new DeletePatientHealthRecordRequest();
    var gReq: GenericProcPostRequest = new GenericProcPostRequest();
    saveReq.ConditionalOperator = 80170;
    saveReq.PatientReportCode = l.PatientReportCode;
    saveReq.ReportType = l.ReportType;
    saveReq.TemplateName = l.TemplateName;
    saveReq.FormattedCode = l.FormattedCode;
    saveReq.ActorCode = l.ActorCode;
    saveReq.UserName = AppData.Instance().UserLoginDetails.UserName;    
    saveReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    var str = JSON.stringify(saveReq);
    gReq.ConditionalOperator = 80170;
    gReq.QueryData = str;
    gReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.Save<GenericProcPostRequest>(
      gReq, S_Methods.SaveGenericPost)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result[0].length > 0) {
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.stopRefreshing();
            this.LoadMedicalHistory(l.PatientReportCode);
            //this.activeModal.close();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            this.stopRefreshing();
          }
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alert(this.ApiResData.ErrorData);
          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },
        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );
  }
    //LoadMedicalHistory_new() {

    //    var r1: OTFormDetailByReportCodeRequest = new OTFormDetailByReportCodeRequest();
    //    r1.ConditionalOperator = 10;
    //    r1.PatientFormattedCode = this.FormattedCode;
    //    r1.PatientReportCode = "";
    //    r1.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    //    this.actorservice.GetOTFormDetailByReportCodeController(r1).subscribe
    //        ((result) => {
    //            this.ApiResData = result;
    //            if (!this.ApiResData.hasError) {
    //                this.stopRefreshing();

    //                this.FormData = this.ApiResData.Result;




    //            }
    //            else {
    //                this.stopRefreshing();
    //                if (this.ApiResData.ErrorData != "") {

    //                    alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
    //                }
    //                else {
    //                    alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
    //                }
    //            }

    //        },


    //            (error) => {

    //                if (error == "401 - Unauthorized") {
    //                    alertFunctions.AlertParamEr(error);
    //                    this.stopRefreshing();



    //                }
    //                else {
    //                    alertFunctions.AlertParamEr(error);
    //                    this.stopRefreshing();
    //                }
    //            }


    //        );

    //}
    displyeditattr(l: SectionData) {
        //this.FormList = false;
        //this.Formedit = true;

       // alert(l.Title);
        const modalRef = this.modalService.open(NgbFsEditAttrModal,
            {
              centered: true,
              size: "xl",
              keyboard: false,
              backdrop: 'static'

            })
        modalRef.componentInstance.sectionData = l;
        modalRef.componentInstance.SectionSequenceNO = l.SectionSequenceNO;
        modalRef.componentInstance.SectionTypeCode = l.SectionTypeCode;
        modalRef.componentInstance.FormattedCode = this.FormattedCode;
        modalRef.componentInstance.TemplateName = this.TemplateName;
        modalRef.componentInstance.Date = this.Date;
        modalRef.componentInstance.Sign1 = this.Sign1;
        modalRef.componentInstance.Sign2 = this.Sign2;
        modalRef.componentInstance.TitleName = l.Title;
        modalRef.componentInstance.PatientReportCode = this.RPCode;
        // modalRef.componentInstance.CurrentActorEditEmergencyInfoRequest = this.CurrentActorEditEmergencyInfoRequest;
        //modalRef.result.then(x => { this.GetEmergencyContactInfoController() })
    }
    displyeditText(l: SectionData) {
        //this.FormList = false;
        //this.Formedit = true;
        const modalRef = this.modalService.open(NgbFsEditTextModal,
            {
                centered: true,
                size: "xl",
                keyboard: false,
                backdrop: 'static'

            })
        modalRef.componentInstance.sectionData = l;
        modalRef.componentInstance.SectionSequenceNO = l.SectionSequenceNO;
        modalRef.componentInstance.SectionTypeCode = l.SectionTypeCode;
        modalRef.componentInstance.FormattedCode = this.FormattedCode;
        modalRef.componentInstance.TemplateName = this.TemplateName;
        modalRef.componentInstance.Date = this.Date;
        modalRef.componentInstance.Sign1 = this.Sign1;
        modalRef.componentInstance.Sign2 = this.Sign2;
        modalRef.componentInstance.TitleName = l.Title;
        modalRef.componentInstance.PatientReportCode = this.RPCode;
        // modalRef.componentInstance.CurrentActorEditEmergencyInfoRequest = this.CurrentActorEditEmergencyInfoRequest;
        //modalRef.result.then(x => { this.GetEmergencyContactInfoController() })
    }
    displyeditImage(l: SectionData) {
        const modalRef = this.modalService.open(NgbFsEditImageModal,
            {
                centered: true,
                size: "xl",
                keyboard: false,
                backdrop: 'static'
            })
        modalRef.componentInstance.sectionData = l;
        modalRef.componentInstance.SectionSequenceNO = l.SectionSequenceNO;
        modalRef.componentInstance.SectionTypeCode = l.SectionTypeCode;
        modalRef.componentInstance.FormattedCode = this.FormattedCode;
        modalRef.componentInstance.TemplateName = this.TemplateName;
        modalRef.componentInstance.Date = this.Date;
        modalRef.componentInstance.Sign1 = this.Sign1;
        modalRef.componentInstance.Sign2 = this.Sign2;
        modalRef.componentInstance.TitleName = l.Title;
        modalRef.componentInstance.PatientReportCode = this.RPCode;
    }
    displytextview() {
        const modalRef = this.modalService.open(NgbFsEditViewModal,
            {
              centered: true,
              keyboard: false,
              backdrop: 'static'

            })
    }
    AddForm() {

        const modalRef = this.modalService.open(NgbAddFormsModal,
            {
              keyboard: false,
              backdrop: 'static'
            })
        modalRef.componentInstance.FormattedCode = this.FormattedCode;
      modalRef.componentInstance.PatientCode = this.PatientCode;
      modalRef.result.then(x => { this.GetOTFormsByFormattedCodeController()})
    }

    GetActorPersonalDetailInfoController() {

        this.StartRefreshing();
        this.hcpservice.GetActorPersonalDetailInfoController(this.CurrentActorPersonalDetailInfoRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {


                    this.CurrentActorPersonalDetailInfoController = this.ApiResData.Result[0];

                    this.CurrentActorPersonalDetailInfoRequest.ConditionalOperator = 2;
                    this.CurrentActorPersonalDetailInfoRequest.ActorCode = this.CurrentActorPersonalDetailInfoController.ActorCode;
                    this.CurrentActorPersonalDetailInfoRequest.Salutation = this.CurrentActorPersonalDetailInfoController.Salutation;
                    this.CurrentActorPersonalDetailInfoRequest.FirstName = this.CurrentActorPersonalDetailInfoController.FirstName;
                    this.CurrentActorPersonalDetailInfoRequest.MiddleName = this.CurrentActorPersonalDetailInfoController.MiddleName;
                    this.CurrentActorPersonalDetailInfoRequest.LastName = this.CurrentActorPersonalDetailInfoController.LastName;
                    this.CurrentActorPersonalDetailInfoRequest.DisplayName = this.CurrentActorPersonalDetailInfoController.DisplayName;
                    this.CurrentActorPersonalDetailInfoRequest.SocialSecurityNumber = this.CurrentActorPersonalDetailInfoController.SocialSecurityNumber;
                    this.CurrentActorPersonalDetailInfoRequest.DateOfBirth = this.CurrentActorPersonalDetailInfoController.DateOfBirth;



                    if (this.CurrentActorPersonalDetailInfoController.DateOfBirth != null) {

                        var SDOB = new Date(this.CurrentActorPersonalDetailInfoController.DateOfBirth);
                        ;
                        if (SDOB.getFullYear() > 1900) {

                            this.DOB = {

                                year: SDOB.getFullYear(),
                                month: SDOB.getMonth() + 1,
                                day: SDOB.getDate()
                            }
                        }
                        else {
                            this.DOB = {

                                year: 1900,
                                month: 1,
                                day: 1
                            }
                        }
                    }
                    this.CurrentActorPersonalDetailInfoRequest.PlaceOfBirth = this.CurrentActorPersonalDetailInfoController.PlaceOfBirth;
                    this.CurrentActorPersonalDetailInfoRequest.Gender = this.CurrentActorPersonalDetailInfoController.Gender;
                    this.CurrentActorPersonalDetailInfoRequest.BloodGroup = this.CurrentActorPersonalDetailInfoController.BloodGroup;
                    this.CurrentActorPersonalDetailInfoRequest.Nationality = this.CurrentActorPersonalDetailInfoController.Nationality;
                    this.CurrentActorPersonalDetailInfoRequest.Religion = this.CurrentActorPersonalDetailInfoController.Religion;
                    this.CurrentActorPersonalDetailInfoRequest.BirthIdentification1 = this.CurrentActorPersonalDetailInfoController.BirthIdentification1;
                    this.CurrentActorPersonalDetailInfoRequest.BirthIdentification2 = this.CurrentActorPersonalDetailInfoController.BirthIdentification2;
                    this.CurrentActorPersonalDetailInfoRequest.LiveIn = this.CurrentActorPersonalDetailInfoController.LiveIn;
                    this.CurrentActorPersonalDetailInfoRequest.Occupation = this.CurrentActorPersonalDetailInfoController.Occupation;
                    this.CurrentActorPersonalDetailInfoRequest.MaritalStatus = this.CurrentActorPersonalDetailInfoController.MaritalStatus;
                    this.CurrentActorPersonalDetailInfoRequest.HasWorkPermit = this.CurrentActorPersonalDetailInfoController.HasWorkPermit;
                    this.CurrentActorPersonalDetailInfoRequest.IsConvicted = this.CurrentActorPersonalDetailInfoController.IsConvicted;
                    this.CurrentActorPersonalDetailInfoRequest.LanguagesSpoken = this.CurrentActorPersonalDetailInfoController.LanguagesSpoken;
                    this.CurrentActorPersonalDetailInfoRequest.LanguagesRead = this.CurrentActorPersonalDetailInfoController.LanguagesRead;
                    //
                    //this.CurrentActorPersonalDetailInfoRequest.ConditionalOperator = 2;
                    //this.CurrentActorPersonalDetailInfoRequest.ActorCode = this.CurrentActorPersonalDetailInfoController.ActorCode;
                    this.CurrentActorPersonalDetailInfoRequest.AddressLine1 = this.CurrentActorPersonalDetailInfoController.AddressLine1;
                    this.CurrentActorPersonalDetailInfoRequest.AddressLine2 = this.CurrentActorPersonalDetailInfoController.AddressLine2;
                    this.CurrentActorPersonalDetailInfoRequest.City = this.CurrentActorPersonalDetailInfoController.City;
                    this.CurrentActorPersonalDetailInfoRequest.State = this.CurrentActorPersonalDetailInfoController.State;
                    this.CurrentActorPersonalDetailInfoRequest.Country = "AMERICA"
                    //this.CurrentActorPersonalDetailInfoController.Country;
                    this.CurrentActorPersonalDetailInfoRequest.Telephone1 = this.CurrentActorPersonalDetailInfoController.Telephone1;
                    this.CurrentActorPersonalDetailInfoRequest.Telephone2 = this.CurrentActorPersonalDetailInfoController.Telephone2;
                    this.CurrentActorPersonalDetailInfoRequest.Fax1 = this.CurrentActorPersonalDetailInfoController.Fax1;
                    this.CurrentActorPersonalDetailInfoRequest.Fax2 = this.CurrentActorPersonalDetailInfoController.Fax2;
                    this.CurrentActorPersonalDetailInfoRequest.Email = this.CurrentActorPersonalDetailInfoController.Email;
                    this.CurrentActorPersonalDetailInfoRequest.EmergencyContactPersonName = this.CurrentActorPersonalDetailInfoController.EmergencyContactPersonName;
                    this.CurrentActorPersonalDetailInfoRequest.EmergencyContactNo1 = this.CurrentActorPersonalDetailInfoController.EmergencyContactNo1;
                    this.CurrentActorPersonalDetailInfoRequest.EmergencyContactNo2 = this.CurrentActorPersonalDetailInfoController.EmergencyContactNo2;
                    this.CurrentActorPersonalDetailInfoRequest.EmergencyAddress = this.CurrentActorPersonalDetailInfoController.EmergencyAddress;
                    this.CurrentActorPersonalDetailInfoRequest.Zip = this.CurrentActorPersonalDetailInfoController.Zip;
                    //
                    this.CurrentActorPersonalDetailInfoRequest.ProfileSummary = this.CurrentActorPersonalDetailInfoController.ProfileSummary;
                    this.CurrentActorPersonalDetailInfoRequest.ProfileTitle = this.CurrentActorPersonalDetailInfoController.ProfileTitle;

                    //this.key = this.ApiResData.Result[0];

                    //this.personalInfoChange.emit(this.key);
                    // console.log('this.personalInfoChange' + this.key.DisplayName);
                    this.stopRefreshing();

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );

    }
    private stopRefreshing() {
        this.loaderService.displayLoader(false);
        this.isRequesting = false;
    }
    private StartRefreshing() {
        this.loaderService.displayLoader(true);
        this.isRequesting = true;
    }
    OpenEditContent() {
        if (this.CanEdit === 1) {
            this.CurrentActorPersonalDetailInfoRequest.ConditionalOperator = 2;
            this.CurrentActorPersonalDetailInfoRequest.ActorCode = this.CurrentActorPersonalDetailInfoController.ActorCode;
            this.CurrentActorPersonalDetailInfoRequest.Salutation = this.CurrentActorPersonalDetailInfoController.Salutation;
            this.CurrentActorPersonalDetailInfoRequest.FirstName = this.CurrentActorPersonalDetailInfoController.FirstName;
            this.CurrentActorPersonalDetailInfoRequest.MiddleName = this.CurrentActorPersonalDetailInfoController.MiddleName;
            this.CurrentActorPersonalDetailInfoRequest.LastName = this.CurrentActorPersonalDetailInfoController.LastName;
            this.CurrentActorPersonalDetailInfoRequest.DisplayName = this.CurrentActorPersonalDetailInfoController.DisplayName;
            this.CurrentActorPersonalDetailInfoRequest.SocialSecurityNumber = this.CurrentActorPersonalDetailInfoController.SocialSecurityNumber;
            this.CurrentActorPersonalDetailInfoRequest.DateOfBirth = this.CurrentActorPersonalDetailInfoController.DateOfBirth;
            this.CurrentActorPersonalDetailInfoRequest.PlaceOfBirth = this.CurrentActorPersonalDetailInfoController.PlaceOfBirth;
            this.CurrentActorPersonalDetailInfoRequest.Gender = this.CurrentActorPersonalDetailInfoController.Gender;
            this.CurrentActorPersonalDetailInfoRequest.BloodGroup = this.CurrentActorPersonalDetailInfoController.BloodGroup;
            this.CurrentActorPersonalDetailInfoRequest.Nationality = this.CurrentActorPersonalDetailInfoController.Nationality;
            this.CurrentActorPersonalDetailInfoRequest.Religion = this.CurrentActorPersonalDetailInfoController.Religion;
            this.CurrentActorPersonalDetailInfoRequest.BirthIdentification1 = this.CurrentActorPersonalDetailInfoController.BirthIdentification1;
            this.CurrentActorPersonalDetailInfoRequest.BirthIdentification2 = this.CurrentActorPersonalDetailInfoController.BirthIdentification2;
            this.CurrentActorPersonalDetailInfoRequest.LiveIn = this.CurrentActorPersonalDetailInfoController.LiveIn;
            this.CurrentActorPersonalDetailInfoRequest.Occupation = this.CurrentActorPersonalDetailInfoController.Occupation;
            this.CurrentActorPersonalDetailInfoRequest.MaritalStatus = this.CurrentActorPersonalDetailInfoController.MaritalStatus;
            this.CurrentActorPersonalDetailInfoRequest.HasWorkPermit = this.CurrentActorPersonalDetailInfoController.HasWorkPermit;
            this.CurrentActorPersonalDetailInfoRequest.IsConvicted = this.CurrentActorPersonalDetailInfoController.IsConvicted;
            this.CurrentActorPersonalDetailInfoRequest.LanguagesSpoken = this.CurrentActorPersonalDetailInfoController.LanguagesSpoken;
            this.CurrentActorPersonalDetailInfoRequest.LanguagesRead = this.CurrentActorPersonalDetailInfoController.LanguagesRead;
            //
            //this.CurrentActorPersonalDetailInfoRequest.ConditionalOperator = 2;
            //this.CurrentActorPersonalDetailInfoRequest.ActorCode = this.CurrentActorPersonalDetailInfoController.ActorCode;
            this.CurrentActorPersonalDetailInfoRequest.AddressLine1 = this.CurrentActorPersonalDetailInfoController.AddressLine1;
            this.CurrentActorPersonalDetailInfoRequest.AddressLine2 = this.CurrentActorPersonalDetailInfoController.AddressLine2;
            this.CurrentActorPersonalDetailInfoRequest.City = this.CurrentActorPersonalDetailInfoController.City;
            this.CurrentActorPersonalDetailInfoRequest.State = this.CurrentActorPersonalDetailInfoController.State;
            this.CurrentActorPersonalDetailInfoRequest.Country = "AMERICA";
            //this.CurrentActorPersonalDetailInfoController.Country;
            this.CurrentActorPersonalDetailInfoRequest.Telephone1 = this.CurrentActorPersonalDetailInfoController.Telephone1;
            this.CurrentActorPersonalDetailInfoRequest.Telephone2 = this.CurrentActorPersonalDetailInfoController.Telephone2;
            this.CurrentActorPersonalDetailInfoRequest.Fax1 = this.CurrentActorPersonalDetailInfoController.Fax1;
            this.CurrentActorPersonalDetailInfoRequest.Fax2 = this.CurrentActorPersonalDetailInfoController.Fax2;
            this.CurrentActorPersonalDetailInfoRequest.Email = this.CurrentActorPersonalDetailInfoController.Email;
            this.CurrentActorPersonalDetailInfoRequest.EmergencyContactPersonName = this.CurrentActorPersonalDetailInfoController.EmergencyContactPersonName;
            this.CurrentActorPersonalDetailInfoRequest.EmergencyContactNo1 = this.CurrentActorPersonalDetailInfoController.EmergencyContactNo1;
            this.CurrentActorPersonalDetailInfoRequest.EmergencyContactNo2 = this.CurrentActorPersonalDetailInfoController.EmergencyContactNo2;
            this.CurrentActorPersonalDetailInfoRequest.EmergencyAddress = this.CurrentActorPersonalDetailInfoController.EmergencyAddress;

            //
            this.CurrentActorPersonalDetailInfoRequest.ProfileSummary = this.CurrentActorPersonalDetailInfoController.ProfileSummary;
            this.CurrentActorPersonalDetailInfoRequest.ProfileTitle = this.CurrentActorPersonalDetailInfoController.ProfileTitle;

        }
        else {
            alertFunctions.AlertParam('Access Denied  Please Contact Admin....!');
        }

    }
  printfclinical() {
    this.printService.printDocument2(this.FormattedCode, 0

    );
    this.printService.printDocument("fclinicalexamination",
      {
        ReportCode: this.RPCode, FormattedCode: this.FormattedCode, TemplateName: this.TemplateName,
      }
    );
  }
  printfclinicalnoheader() {
    this.printService.printDocument("fclinicalexaminationnoheader",
      {
        ReportCode: this.RPCode, FormattedCode: this.FormattedCode, TemplateName: this.TemplateName,
      }
    );
  }

}
